<script>
  import {jenksBreaks, showChange, changeBreaks} from './stores.js'
  import {colorsJenks, colorsChange} from './helpers/colors.js'
  import comma from './helpers/comma.js'

  export let prefix;
  export let suffix;
</script>

<div class="w-100">
  {#if !$showChange}
    {#each colorsJenks as color, i}
      <div class="fl {i < 4 ? 'tr' : 'tl white'} w-20 pv1 ph2 f6" style="background-color:{color}">
        {@html i == 0 ? '&leq;' : ''}
        {i != 4 ? prefix + ($jenksBreaks[i + 1] ? comma($jenksBreaks[i + 1]) : '') + suffix : ''}
        {i == 4 ? prefix + comma($jenksBreaks[i] + 1) + suffix + '+' : ''}
      </div>
    {/each}
  {/if}

  {#if $showChange}
    {#each colorsChange as color, i}
      <div class="fl {i == 0 || i == 3 || i == 4 ? 'tr' : 'tl'} {i == 0 || i == 5 ? 'white' : ''} pv1 ph2 f6" style="background-color:{color};width:16%">
        {@html i == 0 ? '&leq;' + (changeBreaks[i + 1]-1) + '%' : ''}
        { i > 0 && i < 3 ? changeBreaks[i] + '%' : ''}
        { i == 3 || i == 4 ? changeBreaks[i + 1] + '%' : '' }
        { i == 5 ? (changeBreaks[i]+1) + '%+' : ''}
      </div>
    {/each}
  {/if}
</div>
